import queryString from 'query-string';
import http from '../httpConfig';
import { List, AddEditApi } from '../interfaces/stockist.interface';
import { API_ENDPOINTS } from '../utils/apiConstant';
import { buildPagingResponse } from '../utils/methods';

const list = (payload: List) => {
  const { searchText, status, ...others } = payload;
  const paging = buildPagingResponse(others);
  const queryParams: any = {
    ...paging,
    search: searchText,
    status,
  };

  const url = `${API_ENDPOINTS.listStockists}?${queryString.stringify(queryParams)}`;
  return http.get(url);
};

const add = (payload: AddEditApi) => {
  return http.post(API_ENDPOINTS.addStockist, payload);
};

const edit = (id: string, payload: AddEditApi) => {
  return http.put(`${API_ENDPOINTS.editStockist}/${id}`, payload);
};

const deleteStockist = (id: string) => {
  return http.delete(`${API_ENDPOINTS.deleteStockist}/${id}`);
};

const get = (id: string) => {
  return http.get(`${API_ENDPOINTS.getStockist}/${id}`);
};

const lookup = (payload: {
  searchText: string;
}) => {
  // If backend supports lookup for stockists. Assuming standard listing with small page size or dedicated lookup endpoint.
  // Using list endpoint for now with minimal fields if no lookup endpoint exists, or if I should create one.
  // Backend User repo has lookup. Stockist repo I only made list.
  // I will skip lookup or use list with a flag? or just minimal list.
  // For now, I'll point to listStockists but maybe I should have added lookup endpoint in BE.
  // The UI requirement didn't ask for lookup yet (only CRUD).
  // But useful for "Add Branch" -> Select Stockist?
  // I will use listStockists for now.
  const queryParams = {
    search: payload.searchText,
    page: 1,
    pageSize: 100, // Reasonable limit for dropdowns
    status: '1' // Active only
  };
  const url = `${API_ENDPOINTS.listStockists}?${queryString.stringify(queryParams)}`;
  return http.get(url);
};

const StockistService = {
  list,
  add,
  edit,
  delete: deleteStockist,
  get,
  lookup,
};

export default StockistService;
